<template>
 <div class="vt-video" v-definesize="autoSize">
    <!-- Poster -->
    <div v-if="!autoplay" :class="['vt-video__poster lazyload', { 'vt-video__poster--active' : playing }]" 
    :data-bgset="`${this.poster}?mw=800 [(max-width: 767px)] | ${this.poster}?mw=1280`">
      <a class="button button--pause" @click="changeStatus">
        <svg>
          <use xlink:href="#icon-play" />
        </svg>
      </a>
    </div>
    <!-- Video -->
    <video :id="id" ref="video"
      preload="metadata"
      webkit-playsinline="true" playsinline="true"
      width="100%" height="100%" frameborder="0"
      allow="autoplay" controls controlsList="nodownload">

      <source :src="videoUrl" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
  export default {
    name: 'VideoLocal',
    props: {
      autoplay: {
        type: Boolean,
        default: false
      },
      poster: {
        type: String,
        default: null,
        required: true
      },
      videoUrl: {
        type: String,
        default: null,
        required: true
      },
      autoSize: {
        type: Boolean,
        default: true,
        required: true
      }
    },
    data() {
      return {
        id: `video-${Math.floor(Math.random() * 100000)}`,
        player: null,
        playing: false,
        loading: true
      }
    },
    watch: {
      playing(isPlaying) {
        if (isPlaying) {
          this.player.play()
        } else {
          this.player.pause()
        }
      }
    },
    created() {
      this.$root.$on('changeVideo', (payload) => {
        if (payload.id === this.id) {
          switch (payload.command) {
            case 'pause':
              if (!this.playing) return

              this.playing = false
              break
            case 'stop':
              if (this.playing) {
                this.playing = false
              }
              this.player.currentTime = 0
              break
            default:
              window.console.warn(`Command ${payload.command} not found.`)
              break
          }
        }
      })
    },
    mounted() {
      const { video } = this.$refs

      this.player = video

      if (this.autoplay) {
        this.player.play()
      }
    },
    methods: {
      changeStatus() {
        this.pushGTM()
        this.playing = !this.playing
      },
      pushGTM() {
        window.dataLayer.push({
          event: 'video_check_provider',
          video_provider: 'Local'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.vt-video {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;

  video {
    background: #000;
    border: 0;
    outline: none;
  }

  &__poster {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #f8f8f8;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 99;

    &--active {
      visibility: hidden;
    }
  }
}
</style>
